import React from 'react';
import {styled} from '@mui/material/styles';
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {useDispatch, useSelector} from "react-redux";
import ToggleBlackButton from "./ToggleBlackButton";
import ManipulateButton from "./ManipulateButton";
import ResetButton from "./ResetButton";
import {toggleLiveUpdate} from "../../lib/slices/appSlice";

const StyledGrid = styled(Grid)(({theme}) => ({
    padding: theme.spacing(2),
}));

const StyledGridCenter = styled(Grid)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));


const StyledGridItem = ({children, ...otherProps}) => {
    return <StyledGridCenter item xs={6} {...otherProps}>{children}</StyledGridCenter>
}

// TODO: Store toggled red image in memory to quickly switch between
export default function ButtonSection() {
    return (
        <StyledGrid container spacing={2}>
            <StyledGridItem>
                <ToggleBlackButton/>
            </StyledGridItem>

            <StyledGridItem>
                <ResetButton/>
            </StyledGridItem>

        </StyledGrid>
    );
}

